import { render, staticRenderFns } from "./RootNode.vue?vue&type=template&id=eba37d28&scoped=true"
import script from "./RootNode.vue?vue&type=script&lang=js"
export * from "./RootNode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eba37d28",
  null
  
)

export default component.exports